export enum TimeCardEntryType {
  Task = 'Task',
  BundleTask = 'BundleTask',
  CustomTask = 'CustomTask',
  AgentStartLocation = 'AgentStartLocation',
  AgentEndLocation = 'AgentEndLocation',
  Break = 'Break',
  Stop = 'Stop',
  Move = 'Move',
  Unknown = 'Unknown'
}
